import request from "@/utils/request";

export const setRobotBasicInfoPort = data => {
    return request({
        url: "/api/blade-platform/questionbasicconfig/save",
        method: "post",
        data
    });
};
export const getRobotBasicInfoPort = () => {
    return request({
        url: "/api/blade-platform/questionbasicconfig/detail",
        method: "get",
    });
};
